<template>
  <el-dialog
    :visible.sync="visible"
    size="tiny"
    @open="open"
    @close="close"
  >
    <span
      slot="title"
      class="save-block-title"
    >
      {{ $t('editor.save_block') }}
    </span>

    <div class="row">
      <el-input
        v-model="block.name"
        class="col-12 mb-2"
        placeholder="Name the block"
        autofocus
      />
      <el-input
        v-model="block.thumbnail"
        class="col-12 mb-2"
        placeholder="Url to thumbnail"
      />

      <el-select
        v-show="block"
        v-model="block.tags"
        class="col-12"
        multiple
        filterable
        allow-create
        placeholder="Apply block tags"
      >
        <el-option
          v-for="tag in tags"
          :key="tag"
          :label="tag"
          :value="tag"
        />
      </el-select>
    </div>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="cancel">{{ $t('element.property.cta.cancel') }}</el-button>
      <el-button
        type="primary"
        @click="updateAndConfirm"
      >{{ $t('element.property.cta.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import tags from '../../lib/tags'
import * as getters from '../../store/modules/getters'
import * as actions from '../../store/modules/actions'
import * as mutations from '../../store/modules/mutations'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  data () {
    return {
      tags
    }
  },
  computed: {
    ...mapGetters({
      visible: getters.SAVE_BLOCK_VISIBLE,
      block: getters.SAVE_BLOCK_DATA,
      vnode: getters.SAVE_BLOCK_VNODE,
      selected: getters.SELECTOR_SELECTED,
      config: getters.AUTH_GET_USER_CONFIG,
      isGridBuilder: getters.SITE_HAS_GRIDBUILDER
    })
  },
  methods: {
    ...mapMutations({
      close: mutations.SAVE_BLOCK_HIDE,
      setData: mutations.SAVE_BLOCK_SET_DATA,
      updateData: mutations.SAVE_BLOCK_UPDATE_DATA,
      setVnode: mutations.SAVE_BLOCK_SET_VNODE,
    }),
    ...mapActions({
      confirm: actions.SAVE_BLOCK_CONFIRM,
      cancel: actions.SAVE_BLOCK_CANCEL
    }),
    updateAndConfirm () {
      this.block.isGridBuilder = this.isGridBuilder
      this.updateData(this.block)
      this.confirm()
    },
    open () {
      this.setVnode(this.selected.path())
      this.updateData({
        colors: this.selected.internalThemeColors()
      })
    }
  }
}
</script>

<style lang="scss">
  .save-block-title {
    font-size: 1.5em;
    font-weight: bold;
  }
</style>
